export default __webpack_public_path__ + "static/media/warning.e4900575.svg";